export const SUCCESS_HOLIDAY_HOURS = "SUCCESS_HOLIDAY_HOURS";
export const SUCCESS_PLACE_PAUSES = "SUCCESS_PLACE_PAUSES";
export const SUCCESS_CREATE_PLACE_PAUSE = "SUCCESS_CREATE_PLACE_PAUSE";
export const SUCCESS_CREATE_HOLIDAY = "SUCCESS_CREATE_HOLIDAY";
export const SUCCESS_REMOVE_HOLIDAY = "SUCCESS_REMOVE_HOLIDAY";